import { inject } from '@angular/core';
import { CourtsStore } from './courts.store';
import type { SelectOption } from '@td/core';

export function courtsResolver(): Array<SelectOption> | boolean {
  const store = inject(CourtsStore);

  if (store.options().length) return store.options();
  store.loadCourts();

  return store.options();
}
